import getSiteId from './get-site-id';

export default {
  getSiteId,
};
